// O slice da BOAS-VINDAS do primeiro contato (spec-009 [US-2]) — o que o servidor
// respondeu sobre entregar, e o desfecho da marcação.
//
// ★ Arquivo próprio composto no `index.js`, como `hub-e-agente`, `artefato` e `toolParts`:
// é o padrão DESTE módulo. (O gerador `hygen new api` injeta `{data, loading, lastUpdate}`
// nos arquivos raiz da store; aqui isso não serve — não é lista, e o molde do módulo é o
// slice separado.)
//
// ★ QUEM BUSCA É A API. Toda action daqui é setter puro; quem faz o GET/POST, versiona a
// leitura e guarda o duplo clique é `api/apiBoasVindas.js`.

// ── State ─────────────────────────────────────────────────────────────────────────────
export function criarStateBoasVindas() {
  return {
    // Envelope do GET (`{ deve_entregar, motivo, versao_roteiro, entregue_em, canal }`)
    // ou null (não perguntado / leitura falhou).
    //
    // ⚠️ `entregue_em` chega DIA-PRIMEIRO (`DD/MM/YYYY HH:mm`), NUNCA ISO — medido
    // contra o servidor real em 17/09/2026. Ninguém o exibe hoje; quem for exibir
    // precisa de parser com máscara: `aawzDate(valor)` cru lê dia-primeiro como
    // MÊS/DIA e troca os dois em silêncio quando o dia é <= 12 (CLAUDE.md §5.6).
    //
    // ★ `null` NÃO é "deve entregar". Quem não sabe não entrega: mostrar a boas-vindas
    // por omissão é pior do que não mostrar — ela é uma mensagem de PRIMEIRO contato, e
    // repeti-la a quem já a viu é o defeito que a US-2 está tentando evitar.
    boasVindas: null,
    boasVindasLoading: false,
    // Mensagem da leitura que falhou, ou null. Não vira bloco de erro na tela: sem
    // resposta, a boas-vindas simplesmente não acontece, e o chat segue normal.
    //
    // ⚠️ O texto aqui pode ser TÉCNICO e em inglês — num 401 real ele é
    // `'Request failed with status code 401(401)'`, que o `connection.js` monta. Serve
    // ao DIAGNÓSTICO, que é para o que este campo existe. Quem um dia o levar à TELA
    // precisa da régua do módulo (`mensagemAmigavelDoErro`, que descarta a string do
    // transporte pelo sufixo `(<código>)` e cai na copy PT-BR).
    boasVindasErro: null,

    // ── A MARCAÇÃO ──
    // Guard BLOQUEANTE do POST: o segundo pedido não sai. O servidor é idempotente
    // (`ja_entregue`), mas duas idas à rede para marcar a mesma entrega são desperdício.
    boasVindasEntregaLoading: false,
    // Mensagem da marcação que falhou. Existe para diagnóstico — a TELA não muda por
    // causa dela: a boas-vindas já foi vista, e apagá-la agora seria punir o consultor
    // por uma falha nossa.
    boasVindasEntregaErro: null,
  }
}

// ── Getters ───────────────────────────────────────────────────────────────────────────
export const boasVindasGetters = {
  boasVindas: (s) => s.boasVindas,
  boasVindasLoading: (s) => s.boasVindasLoading,
  boasVindasErro: (s) => s.boasVindasErro,
  boasVindasEntregaLoading: (s) => s.boasVindasEntregaLoading,
  boasVindasEntregaErro: (s) => s.boasVindasEntregaErro,
  // ★ A régua da tela, num lugar só: só entrega quando o SERVIDOR disse que sim.
  deveEntregarBoasVindas: (s) => Boolean(s.boasVindas && s.boasVindas.deve_entregar),
}

// ── Mutations ─────────────────────────────────────────────────────────────────────────
export const boasVindasMutations = {
  SET_BOAS_VINDAS(s, payload) {
    s.boasVindas = payload || null
  },
  SET_BOAS_VINDAS_LOADING(s, payload) {
    s.boasVindasLoading = Boolean(payload)
  },
  SET_BOAS_VINDAS_ERRO(s, payload) {
    s.boasVindasErro = payload || null
  },
  SET_BOAS_VINDAS_ENTREGA_LOADING(s, payload) {
    s.boasVindasEntregaLoading = Boolean(payload)
  },
  SET_BOAS_VINDAS_ENTREGA_ERRO(s, payload) {
    s.boasVindasEntregaErro = payload || null
  },
}

// ── Actions ───────────────────────────────────────────────────────────────────────────
// Setters: só commitam. Quem os chama é a `apiBoasVindas`.
export const boasVindasActions = {
  setBoasVindas({ commit }, payload) {
    commit('SET_BOAS_VINDAS', payload)
  },
  setBoasVindasLoading({ commit }, payload) {
    commit('SET_BOAS_VINDAS_LOADING', payload)
  },
  setBoasVindasErro({ commit }, payload) {
    commit('SET_BOAS_VINDAS_ERRO', payload)
  },
  setBoasVindasEntregaLoading({ commit }, payload) {
    commit('SET_BOAS_VINDAS_ENTREGA_LOADING', payload)
  },
  setBoasVindasEntregaErro({ commit }, payload) {
    commit('SET_BOAS_VINDAS_ENTREGA_ERRO', payload)
  },
}
